import * as Types from '../constants/Types';
import { PAGINATION } from '../constants/Define';
import RateCode, { RateCodeSchedule } from '../models/RateCode';
import { STOCK_PRODUCTS_SUCCESS } from './../constants/Types/RateCode';

const initialState = {
    isFetching: false,
    isFetchingDetail: false,
    isFetchingCampaign: false,
    isFetchingStockProducts: false,
    pageSize: PAGINATION.pageSize,
    pageIndex: PAGINATION.pageIndex,
    totalCount: PAGINATION.totalCount,
    rateCodes: [],
    rateCodeAll: [],
    rateCodePaging: [],
    rateCodePagingPageSize: PAGINATION.pageSize,
    rateCodePagingPageIndex: PAGINATION.pageIndex,
    rateCodePagingTotalCount: PAGINATION.totalCount,
    rateCodeDetailMap: {},
    rateCodeCampaigns: [],
    stockProducts: [],
    rateCodeDetail: new RateCode({
        adult: 2,
        child: 1,
        room: 1,
        lengOfStay: 1
    }),
    rateCodeSchedule: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.RATECODE_LIST_ALL_ACTION:
            return { ...state, isFetching: true };
        case Types.RATECODE_LIST_ALL_SUCCESS:
            return {
                ...state, isFetching: false,
                rateCodeAll: action.result
            };
        case Types.RATECODE_LIST_WITH_PAGING_ACTION:
            return { ...state, isFetching: true };
        case Types.RATECODE_LIST_WITH_PAGING_SUCCESS:
            return {
                ...state,
                isFetching: false,
                rateCodePaging: action.result,
                rateCodePagingPageSize: action.pageSize,
                rateCodePagingPageIndex: action.pageIndex,
                rateCodePagingTotalCount: action.totalCount,
            };
        case Types.RATECODE_LIST_ACTION:
            return { ...state, isFetching: true };
        case Types.RATECODE_LIST_SUCCESS:
            return {
                ...state, isFetching: false,
                rateCodes: action.result,
                pageSize: action.pageSize,
                pageIndex: action.pageIndex,
                totalCount: action.totalCount,
                totalPage: Math.ceil(parseInt(action.totalCount) / parseInt(action.pageSize)),
            };

        case Types.RATECODE_DETAIL_CREATE_ACTION:
            return { ...state, isFetchingCampaign: true };
        case Types.RATECODE_CAMPAIGN_LIST_SUCCESS:
            return { 
                ...state, isFetchingCampaign: false, 
                rateCodeCampaigns: action.result
            };

        case Types.RATECODE_DETAIL_ACTION:
            return { ...state, isFetchingDetail: true, rateCodeDetail: {} };
        case Types.RATECODE_DETAIL_SUCCESS:
            return {
                ...state,
                isFetchingDetail: false,
                rateCodeDetail: action.rateCode
            };
        case Types.RATECODE_DETAIL_CACHE_ACTION:
            return { ...state, isFetchingDetail: true };
        case Types.RATECODE_DETAIL_CACHE_SUCCESS:
            return {
                ...state,
                isFetchingDetail: false,
                rateCodeDetailMap: {
                    ...state.rateCodeDetailMap,
                    [action.rateCode.id]: action.rateCode,
                }
            };

        case Types.RATECODE_UPDATE_ACTION:
            return { ...state, isFetchingCampaign: true };
        case Types.RATECODE_UPDATE_SUCCESS:
            return { 
                ...state, isFetchingCampaign: false
            };

            
        case Types.RATECODE_SCHEDULE_ACTION:
            return { ...state, isFetchingDetail: true, rateCodeDetail: {} };
        case Types.RATECODE_SCHEDULE_SUCCESS:
            return {
                ...state,
                isFetchingDetail: false,
                rateCodeSchedule: action.rateCodeSchedule
            };
        // case Types.TICKET_UPDATE_ACTION:
        //     return { ...state, isFetchingDetail: true };
        // case Types.TICKET_UPDATE_SUCCESS:
        //     return { ...state, isFetchingDetail: false };
        case Types.STOCK_PRODUCTS_ACTION:
            return {
              ...state,
              isFetchingStockProducts: true,
              stockProducts: []
            };
        case Types.STOCK_PRODUCTS_SUCCESS:
            return {
                ...state,
                isFetchingStockProducts: false,
                stockProducts: action.data
            };
        case Types.RATECODE_FAIL:
            return { ...state, isFetching: false, isFetchingDetail: false, isFetchingCampaign: false };
        default:
            return state;
    }
}
